import { uniqBy } from 'lodash';

import entityTypes from '../constants/entityTypes';
import { requestTypes } from '../constants/requestTypes';
import {
  IRequest,
  ITransaction,
  TransactionParty,
  UnknownTransactionParty,
} from '../components/request/types';
import { getEntityDisplayName } from '../customFields/EntityDisplayNameField';

export type CaseProcessor = TransactionParty | UnknownTransactionParty;

// Unknown processors have no id, so they are told apart by the name shown on their chip
export const getProcessorKey = (processor: CaseProcessor) => (
  processor.type === entityTypes.UNKNOWN
    ? `${entityTypes.UNKNOWN}:${getEntityDisplayName({ record: processor, type: entityTypes.UNKNOWN })}`
    : `${processor.type}:${processor.id}`
);

const isTransaction = (request: IRequest): request is ITransaction => (
  request.requestType === requestTypes.TRANSACTION
);

// Only the processor of Transaction Requests counts, never the sub-processor
const getCaseProcessors = (requests: (IRequest | undefined)[]): CaseProcessor[] => uniqBy(
  requests
    .filter((request): request is ITransaction => !!request && isTransaction(request))
    .map((request) => request.extraInformation?.processor)
    .filter((processor): processor is CaseProcessor => !!processor?.type),
  getProcessorKey,
);

export default getCaseProcessors;
